import React from 'react';
import ReactDOM from 'react-dom';
import { loadDOMComponent } from '../../helpers';
import { AppContextProvider } from '../../Services/AppContext';
import MeddiDiabetes from '../HealthPlan/Diabetes/MeddiDiabetes';

loadDOMComponent({
	selector: 'react-meddi-diabetes',
	callback: ({ container, context, props }) => {
		const patientId = container.getAttribute('patientId');

		ReactDOM.render(
			<AppContextProvider {...context}>
				<MeddiDiabetes patientId={patientId} />
			</AppContextProvider>,
			container,
		);
	},
});
